<template>
  <div class="create-team">
    <el-form
      v-loading="loading"
      :model="overtimeRuleForm"
      :rules="rules"
      ref="overtimeRuleForm"
      class="white-bg form"
      label-position="left"
      label-width="160px"
    >
      <div class="flex flex-v-center flex-h-bet">
        <h3 class="text-gray bold mt-0 mb-40">
          {{ !isEdit ? "Create" : "Edit" }} Overtime Rules
        </h3>
        <div class="btn-wrapper mb-10 mr-20 move-right">
          <router-link
            to="/admin/attendance/overtime/settings/overtime-rules"
            class="btn-back"
          >
            <span> Back</span>
          </router-link>
        </div>
      </div>
      <div class="mt-20 border">
        <el-form-item prop="group_name" label="Group Name">
          <el-input
            placeholder="Enter group name"
            v-model="overtimeRuleForm.group_name"
          ></el-input>
        </el-form-item>
        <el-form-item prop="description" label="Description">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Enter description"
            v-model="overtimeRuleForm.description"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          label="Do you want to tie this overtime rules to your workshift ?"
          label-width="400px"
          class="mt-20"
          prop="use_work_shift"
        >
          <el-radio-group
            v-model="overtimeRuleForm.use_work_shift"
            class="mt-10"
            ><img src="/img/alert-circle.svg" alt="" class="mr-20" />
            <el-radio :label="true">Yes</el-radio>
            <el-radio :label="false">No</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="mt-20 border">
        <h4 class="text-gray bold mt-20 mb-40">Overtime Rules</h4>
        <el-form-item
          label="Overtime starts"
          class="mt-20"
          prop="overtime_start"
        >
          <el-input-number
            v-model="overtimeRuleForm.overtime_start"
            controls-position="right"
            :min="0"
            :max="60"
          ></el-input-number>
          <span class="ml-10">
            <span class="bold">minutes</span> after workhours ends</span
          >
        </el-form-item>
        <el-form-item label="Overtime ends" class="mt-20" prop="overtime_end">
          <el-input-number
            v-model="overtimeRuleForm.overtime_end"
            controls-position="right"
            :min="0"
            :max="60"
          ></el-input-number>
          <span class="ml-10">
            <span class="bold">minutes</span> after workhours ends</span
          >
        </el-form-item>

        <el-form-item label="Round up" class="mt-20" prop="overtime_round_up">
          <el-input-number
            v-model="overtimeRuleForm.overtime_round_up"
            controls-position="right"
            :min="0"
            :max="60"
          ></el-input-number>
          <span class="ml-10">
            <span class="bold">minutes</span> to 1 hour</span
          >
        </el-form-item>
      </div>

      <div class="mt-20 border">
        <h4 class="text-gray bold mt-20 mb-40">
          Workday Rules <img src="/img/alert-circle.svg" alt="" />
        </h4>
        <div v-if="!overtimeRuleForm.use_work_shift">
          <div class="inline-flex">
            <el-form-item
              label="Apply when"
              label-width="100px"
              prop="work_type"
            >
              <el-select
                v-model="overtimeRuleForm.work_type"
                placeholder=""
                class="inline-select"
              >
                <el-option
                  v-for="item in workOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span class="ml-10"> is greater than </span>
            </el-form-item>
            <el-form-item label-width="0" prop="work_type">
              <el-time-picker
                v-model="overtimeRuleForm.work_time"
                class="inline-time"
                placeholder="work time"
                value-format="HH:mm:ss"
              >
              </el-time-picker>
            </el-form-item>
          </div>
          <el-form-item
            class="mt-20"
            label="Select Workdays"
            prop="work_day_ids"
          >
            <el-checkbox-group v-model="overtimeRuleForm.work_day_ids">
              <el-checkbox label="1">Monday</el-checkbox>
              <el-checkbox label="2">Tuesday</el-checkbox>
              <el-checkbox label="3">Wednesday</el-checkbox>
              <el-checkbox label="4">Thursday</el-checkbox>
              <el-checkbox label="5">Friday</el-checkbox>
              <el-checkbox label="6">Saturday</el-checkbox>
              <el-checkbox label="7">Sunday</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>

        <el-form-item label-width="0" prop="apply_overtime_on_work_day">
          <el-checkbox v-model="overtimeRuleForm.apply_overtime_on_work_day"
            >Apply overtime rates when employees work on workdays they weren’t
            suppose to work</el-checkbox
          >
        </el-form-item>
      </div>

      <div class="mt-20 border">
        <h4 class="text-gray bold mt-20 mb-40">
          Non-Workday Rules <img src="/img/alert-circle.svg" alt="" />
        </h4>
        <el-form-item
          label-width="0"
          class="mt-20"
          prop="apply_overtime_on_non_work_day"
        >
          <el-checkbox v-model="overtimeRuleForm.apply_overtime_on_non_work_day"
            >Apply overtime rates when employees work on their
            non-workdays</el-checkbox
          >
        </el-form-item>
      </div>

      <div class="mt-20 border">
        <h4 class="text-gray bold mt-20 mb-40">
          Public Holidays <img src="/img/alert-circle.svg" alt="" />
        </h4>
        <el-form-item label-width="0" class="mt-20" prop="public_holiday">
          <el-checkbox v-model="overtimeRuleForm.public_holiday"
            >Treat public holidays as a workday</el-checkbox
          >
        </el-form-item>
      </div>

      <div class="mt-20">
        <h4 class="text-gray bold mt-20 mb-40">Overtime Rate Calculation</h4>
        <el-form-item
          class="mt-20"
          label="I want to use"
          label-width="120px"
          prop="payment_type"
        >
          <el-radio-group v-model="overtimeRuleForm.payment_type" class="mt-10">
            <el-radio :label="true">A fixed rate</el-radio>
            <el-radio :label="false">Ratio</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="overtimeRuleForm.payment_type"
          class="mt-20"
          label="Overtime Rate Per Hour"
          label-width="200px"
          prop="amount"
        >
          <el-input
            placeholder="Enter rate"
            v-model="overtimeRuleForm.amount"
            @keypress.native="onlyNumbers"
            class="inline-input"
          ></el-input>
        </el-form-item>
        <div class="flex" v-if="!overtimeRuleForm.payment_type">
          <el-form-item
            label="Overtime Rate Per Hour is"
            label-width="200px"
            prop="ratio"
            :rules="{
              required: true,
              validator: percentageValidation,
              message: 'Enter percentage value (1-100)',
              trigger: 'blur',
            }"
          >
            <el-input
              class="small"
              placeholder="Enter rate"
              v-model="overtimeRuleForm.ratio"
              @keypress.native="onlyNumbers"
            >
            </el-input>
          </el-form-item>
          <div class="ml-10 mt-10 small">of employee’s work rate per hour</div>
        </div>
      </div>

      <div class="mt-20 mb-40">
        <div class="btn-wrapper mt-20 sec-span">
          <el-button
            class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="create()"
            :loading="loading"
            >{{ !isEdit ? "Create" : "Save Changes" }}</el-button
          >
          <button class="btn-cancel mr-15" @click.prevent="$router.go(-1)">
            Cancel
          </button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/attendance/overtime");
import { onlyNumbers } from "@/helpers/validation.js";

export default {
  data() {
    return {
      isEdit: false,
      overtimeRuleForm: {
        group_name: "",
        description: "",
        use_work_shift: true,
        overtime_start: null,
        overtime_end: null,
        overtime_round_up: null,
        work_type: "workday",
        work_time: "",
        work_day_ids: [],
        apply_overtime_on_work_day: false,
        apply_overtime_on_non_work_day: false,
        public_holiday: false,
        payment_type: true,
        amount: null,
        ratio: null,
      },
      workOption: [
        { label: "Workday", value: "WORKDAY" },
        // { label: "Work-week", value: "WORKWEEK" }
      ],
      loading: false,
      rules: {
        group_name: [{ required: true, message: "Please enter group name" }],
        description: [{ required: true, message: "Please enter description" }],
        amount: [{ required: true, message: "Please enter fixed amount" }],
        ratio: [{ required: true, message: "Please enter percentage value" }],
        work_time: [{ required: true, message: "Please enter work time" }],
      },
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.fetchOvertimeRule(id);
    }
    this.isEdit = id ? true : false;
  },
  methods: {
    onlyNumbers,
    percentageValidation(rule, value, callback) {
      if (!value || value < 1 || value > 100) {
        return callback(new Error(`Please select ${rule.field}`));
      }
      return callback();
    },
    ...mapActions(["createRule", "updateRule", "getRuleById"]),
    fetchOvertimeRule(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/attendance/overtime/getRuleById", id)
        .then(response => {
          this.loading = false;
          const {
            group_name,
            description,
            use_work_shift,
            overtime_start,
            overtime_end,
            overtime_round_up,
            work_type,
            work_time,
            work_day_ids,
            apply_overtime_on_work_day,
            apply_overtime_on_non_work_day,
            public_holiday,
            payment_type,
            amount,
          } = response.data;
          this.overtimeRuleForm = {
            ...this.overtimeRuleForm,
            group_name,
            description,
            use_work_shift: use_work_shift === 0 ? false : true,
            overtime_start,
            overtime_end,
            overtime_round_up,
            work_type,
            work_time,
            work_day_ids: work_day_ids.map(String),
            apply_overtime_on_work_day:
              apply_overtime_on_work_day === 0 ? false : true,
            apply_overtime_on_non_work_day:
              apply_overtime_on_non_work_day === 0 ? false : true,
            public_holiday: public_holiday === 0 ? false : true,
            payment_type: payment_type === "fixed" ? true : false,
            amount,
            ratio: amount,
          };
        })
        .catch(() => {
          this.loading = false;
        });
    },
    create() {
      this.$refs[`overtimeRuleForm`].validate(valid => {
        if (valid) {
          this.loading = true;
          const inputData = {
            group_name: this.overtimeRuleForm.group_name,
            description: this.overtimeRuleForm.description,
            use_work_shift: this.overtimeRuleForm.use_work_shift,
            overtime_start: this.overtimeRuleForm.overtime_start,
            overtime_end: this.overtimeRuleForm.overtime_end,
            overtime_round_up: this.overtimeRuleForm.overtime_round_up,
            work_type: this.overtimeRuleForm.work_type,
            work_day_ids: this.overtimeRuleForm.work_day_ids,
            apply_overtime_on_work_day: this.overtimeRuleForm
              .apply_overtime_on_work_day,
            apply_overtime_on_non_work_day: this.overtimeRuleForm
              .apply_overtime_on_non_work_day,
            public_holiday: this.overtimeRuleForm.public_holiday,
            payment_type:
              this.overtimeRuleForm.payment_type === true
                ? "fixed"
                : "premium_pay",
            ...(this.overtimeRuleForm.payment_type === true && {
              amount: this.overtimeRuleForm.amount,
            }),
            ...(this.overtimeRuleForm.payment_type === false && {
              amount: this.overtimeRuleForm.ratio,
            }),
            ...(this.overtimeRuleForm.use_work_shift === false && {
              work_time: this.overtimeRuleForm.work_time,
            }),
          };

          if (this.isEdit) {
            const id = this.$route.params.id;
            this.$store
              .dispatch("admin/attendance/overtime/updateRule", {
                data: inputData,
                id,
              })
              .then(() => {
                this.loading = false;
                this.$router.push(
                  "/admin/attendance/overtime/settings/overtime-rules"
                );
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            this.$store
              .dispatch("admin/attendance/overtime/createRule", inputData)
              .then(() => {
                this.loading = false;
                this.$router.push(
                  "/admin/attendance/overtime/settings/overtime-rules"
                );
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.el-select.inline-select {
  width: 50% !important;
}
.el-input.inline-input {
  width: 20% !important;
}
.el-time-picker.inline-time {
  width: 20% !important;
}
.input-with-select .el-input-group__append {
  width: 10px !important;
}
</style>
